import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Modal, Button, Form } from "react-bootstrap";
import * as XLSX from "xlsx";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import SocieteAndUserService from "../../../services/societeAndUser";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import PurchaseService from "../../../services/PurchaseOrder";
import UploadPdfFile from "../../../ui/UploadPdfFile";
import UploadFactureFile from "../../../ui/UploadFactureFile";
import SellingService from "../../../services/SellingService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../utils/UtilsFormule";
import BillService from "../../../services/BillService";
import toastr from "toastr";
const FactureNonConfirme = ({ listFacture }) => {
  const navigate = useNavigate();

  const [inConfirmedFacture, setInConfirmedFacture] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  //   const [clients, setClients] = useState(listFacture);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [inConfirmedDevis, setInConfirmedDevis] = useState([]);
  const [factureUploadInformation, setFactureUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedFacture: inConfirmedFacture,
  });
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [selectedReference, setSelectedReference] = useState([]);
  const [selectedId, setSelectedId] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [terminedFacture, setTerminedFacture] = useState([]);
  const [archivedFacture, setArchivedFacture] = useState([]);
  const [factureRelatedToInvoice, setFactureRelatedToInvoice] = useState([]);
  const { SearchBar } = Search;
  const fmt = (v) => v != null ? parseFloat(Number(v).toFixed(3)) : "";
  const MyExportExcel = () => {
    const handleExport = () => {
      const rows = listFacture.map((row) => ({
        "Réf":        row.reference,
        "Client":     row.title,
        "Prix.V.HT":  fmt(row.buyingPrice),
        "Prix.V.TT":  fmt(row.ttPrice),
        "TVA":        fmt(Number(row.ttPrice) - Number(row.buyingPrice)),
        "Timbre":     1,
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Factures Vente");
      XLSX.writeFile(wb, `factures_vente_${new Date().toISOString().split("T")[0]}.xlsx`);
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleExport}>
          <i className="fas fa-file-excel"></i> Télécharger Excel
        </button>
      </div>
    );
  };
  

  // const onDeleteOrRestaureSociete = (isDeleted, idSociete, index, state) => {
  //   SocieteAndUserService.deleteAndRestaureSociete(idSociete, isDeleted)
  //     .then((response) => {
  //       if (Object.keys(response.data)[0] === "success") {
  //         window.location.href = "/tiers";
  //       } else if (Object.keys(response.data)[0] === "error") {
  //       }
  //     })
  //     .catch(() => {
  //       setOpenErrorAlert(true);
  //       setErrorAlertText("Erreur : il ya un probléme de connection");
  //     });

  //   console.log("index", index);
  // };
  // const onArchiveHandler = (refDocument, isDeleted) => {
  //   PurchaseService.deleteAndRestoreDevis(refDocument, isDeleted)
  //     .then((response) => {
  //       if (Object.keys(response.data)[0] === "success") {
  //         window.location.reload(false);
  //       }
  //     })
  //     .catch(() => {
  //       setOpenErrorAlert(true);
  //       setErrorAlertText("Erreur : il ya un probléme de connection");
  //     });
  // };

  // function buttonDeleteFormatter(cell, row) {
  //   return (
  //     <button
  //       style={{ width: 40 }}
  //       class="btn btn-danger btn-sm"
  //       onClick={() => onArchiveHandler(row.reference, 1)}
  //     >
  //       <i class="fas fa-trash"></i>
  //     </button>
  //   );
  // }

  // const onUploadFileHandler = (state, reference, isDeleted) => {
  //   SellingService.generateFacture(getCurrentUserId(), reference).then(
  //     (response) => {
  //       console.log("response", response);
  //       onShowFileInOtherWizndowHandler(response.data.facture.path);
  //     }
  //   );
  // };
  // function buttonFileFormatter(cell, row) {
  //   if (row.path !== "any" && row.path !== null && row.path !== "string") {
  //     return (
  //       <button
  //         style={{ width: 40 }}
  //         class="btn bg-gray btn-sm "
  //         onClick={() =>
  //           onShowFileInOtherWizndowHandler(
  //             // UtilsUrl.sellingFileURL() +
  //             row.path
  //           )
  //         }
  //       >
  //         <i class="fas fa-eye"></i>
  //       </button>
  //     );
  //   } else {
  //     return (
  //       <span>
  //         <button
  //           style={{ width: 40 }}
  //           class="btn bg-gray btn-sm text-center"
  //           onClick={() =>
  //             onUploadFileHandler(row.state, row.reference, row.isDeleted)
  //           }
  //         >
  //           <i class="fas fa-plus"></i>
  //         </button>
  //       </span>
  //     );
  //   }
  // }

  function buttonDevisFormatter(cell, row) {
    if (row.devisReference === "any") {
      return (
        <span>
          <i class="fas fa-solid fa-ban"></i>
        </span>
      );
    } else if (row.devisReference !== "any") {
      return <span>{row.devisReference}</span>;
    }
  }

  const onViewProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "bdc");
    const pdfWindow = window.open();
    pdfWindow.location.href = "/getDocumentSalesByRef";
    // navigate("/getDocumentSalesByRef");
  };
  function buttonBDCFormatter(cell, row) {
    if (row.bdcReference === "any") {
      return (
        <span>
          <i class="fas fa-solid fa-ban"></i>
        </span>
      );
    } else if (row.bdcReference !== "any") {

      return <button
        // style={{ width: 40 }}
        class="btn bg-gray btn-sm "
        onClick={() => onViewProductsHandler(row.bdcReference, row.note)}
      ><span>{row.bdcReference}</span>

      </button>
      // return <span>{row.bdcReference}</span>;
    }
  }



  const onAddTaxHandler = (id) => {
    sessionStorage.setItem("idTax", id);
    sessionStorage.setItem("typeToTax", "Devis");
    navigate("/addTaxAndCharge");
  };
  function buttonChargeFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-gray-dark btn-sm "
        onClick={() => {
          console.log("element", row);
          onAddTaxHandler(row.reference);
        }}
      >
        <i class="fas fa-plus"></i>
      </button>
    );
  }

  const onViewFactureProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "facture");
    // window.open('/getDocumentSalesByRef','_blank', 'rel=noopener noreferrer')
    const pdfWindow = window.open();
    pdfWindow.location.href = "/getDocumentSalesByRef";
    // navigate("/getDocumentSalesByRef");
  };

  function buttonDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-black btn-sm "
        onClick={() => onViewFactureProductsHandler(row.reference, row.note)}
      >
        <i class="fas fa-shopping-cart"></i>
      </button>
    );
  }
  function buttonAvoirFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-black btn-sm "
        onClick={() => {
          setSelectedReference(row.reference);
          setSelectedId(row.factureId)
          setShowModal(true);
          // (row.reference, row.note)
        }}
      >
        <i className="fas fa-receipt"></i>
      </button>
    );
  }

  function dateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.creationDate)}</span>;

  }
  const columns = [
    {
      dataField: "reference",
      text: "Réf",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "title",
      text: "Client",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      formatter: dateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "buyingPrice",
      text: "P.V.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "P.V.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },

    {
      dataField: "bdcReference",
      text: "BDC",
      formatter: buttonBDCFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },

    {
      dataField: "factureId",
      text: "Charge",
      formatter: buttonChargeFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "state",
      text: "Info",
      formatter: buttonDetailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    // {
    //   dataField: "state",
    //   text: "Avoir",
    //   formatter: buttonAvoirFormatter,
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "8%" };
    //   },
    // },
  ];
  const handleAvoir = () => {
    SellingService.AvoirFacture(getCurrentUserId(), selectedId).then((r) => {
      setShowModal(false);
      toastr.success('Avoir facture created avec succès');
    }).catch((error) => {
      console.error(error);
      toastr.error('Failed to create Avoir facture. Please try again.');
    });
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les factures de vente</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="factureId"
          data={listFacture}
          columns={columns}
          onTableChange={handleTableChange}
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportExcel />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                //   expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {onUploadFile && (
        <UploadFactureFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedFacture={setInConfirmedFacture}
          setTerminedFacture={setTerminedFacture}
          setFactureRelatedToInvoice={setFactureRelatedToInvoice}
          factureUploadInformation={factureUploadInformation}
          setArchivedFacture={setArchivedFacture}
        />
      )}
      <Modal show={showModal} onHide={() => {
        setShowModal(false)
      }}>
        <Modal.Body>
          <Modal.Title>Êtes-vous sûr de vouloir créer un avoir basé sur cette facture ?</Modal.Title>
          <p><strong>Référence de la facture :</strong> {selectedReference}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowModal(false)
          }}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handleAvoir}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default FactureNonConfirme;
